import React, { memo } from "react";
import CoursePage from "../../study/course_page";

const CoursePreviewPage = () => {
  return <CoursePage inComponent={"admin_page"} />;
};

export default memo(CoursePreviewPage);
